import { render, staticRenderFns } from "./DevelopBase.vue?vue&type=template&id=a9f1a51a&scoped=true&"
import script from "./DevelopBase.vue?vue&type=script&lang=js&"
export * from "./DevelopBase.vue?vue&type=script&lang=js&"
import style0 from "./DevelopBase.vue?vue&type=style&index=0&id=a9f1a51a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f1a51a",
  null
  
)

export default component.exports